/*
 * Inits the builder showcase about page
 */
define(
  'locationsInitializer',[
    'searchComponentLoader',
    'lazyLoad',
    'sectionLazyLoad',
    'favoritesLoader',
    'searchTypeHelper',
    'trackerLocationsSearch',
    'askQuestionLoader',
  ],
  (searchComponentLoader) => {
    'use strict';

    function onDomComplete() {
      const dependenciesModuleName = document.querySelector('[data-ismobiledevice="true"]')
        ? 'mapLocationsBuilderShowCaseMobileLoader'
        : 'mapLocationsBuilderShowCaseDesktopLoader';

      require([dependenciesModuleName]);
    }

    if (document.readyState === 'complete') {
      onDomComplete();
    } else {
      window.addEventListener('load', onDomComplete);
    }

    const searchConfig = {
      cssBundle: '#locationsTypeAheadCss',
      form: '#nhs_locationsSearchForm',
      shouldAlwaysSubmitForm: true,
      submitButton: '[data-search-submit-locations]',
      useAutocompleteForSubmit: true,
      validationError: '#nhs_locations_field_validation_error',
      searchTextField: '#nhs_locations_SearchNav',
      componentToInteract: '#nhs_locations_SearchNav',
    };
    searchComponentLoader.init(searchConfig);
  }
);

